// src/utils/dateKeys.js
export function getDateKey(timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    const now = new Date();
    const y = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric' }).format(now);     // en-CA -> YYYY
    const m = new Intl.DateTimeFormat('en-CA', { timeZone, month: '2-digit' }).format(now);    // MM
    const d = new Intl.DateTimeFormat('en-CA', { timeZone, day: '2-digit' }).format(now);      // DD
    return `${y}-${m}-${d}`; // YYYY-MM-DD
  }
  
  export function getYesterdayKey(timeZone) {
    const now = new Date();
    const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Move back 24h in wall time of tz
    const local = new Date(new Date(now).toLocaleString('en-US', { timeZone: tz }));
    local.setDate(local.getDate() - 1);
    const y = local.getFullYear();
    const m = String(local.getMonth() + 1).padStart(2, '0');
    const d = String(local.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  